import React from 'react';
import { Skeleton } from '@opendate-app/setlist';

export const KpiCardSkeleton = ({ showBottom = true }) => (
  <div style={{ background: 'var(--sl-bg-primary, #fff)', border: '1px solid var(--sl-border-secondary, #e4e7ec)', borderRadius: 8, padding: '16px 16px 14px' }}>
    <Skeleton width="60%" height={14} style={{ marginBottom: 12 }} />
    <Skeleton width="40%" height={28} style={{ marginBottom: 8 }} />
    <Skeleton width="50%" height={14} />
    {showBottom && (
      <div style={{ borderTop: '1px solid var(--sl-bg-tertiary, #f2f4f7)', marginTop: 12, paddingTop: 12 }}>
        <Skeleton width="60%" height={14} style={{ marginBottom: 12 }} />
        <Skeleton width="40%" height={24} style={{ marginBottom: 8 }} />
        <Skeleton width="50%" height={14} />
      </div>
    )}
  </div>
);

export const SalesCardSkeleton = () => (
  <div className="card mb-4">
    <div className="card-body" style={{ padding: 20 }}>
      <Skeleton width="20%" height={18} style={{ marginBottom: 8 }} />
      <Skeleton width="15%" height={28} style={{ marginBottom: 4 }} />
      <Skeleton width="25%" height={14} style={{ marginBottom: 20 }} />
      <Skeleton width="100%" height={200} radius={8} />
    </div>
  </div>
);

export const BarChartSkeleton = () => (
  <div className="card" style={{ flex: 1, minWidth: 0 }}>
    <div className="card-body">
      <Skeleton width="60%" height={16} style={{ marginBottom: 16 }} />
      <Skeleton width="100%" height={250} radius={8} />
    </div>
  </div>
);
